import { Grid, Typography, Box } from "@mui/material";
import React from "react";
import "./ParagraphCard.css";

export default function ParagraphCard() {
  return (
    <div className="slick-slder-data weekend-traveling-section">
      <div className="swiper weekendSwiper swiper-fade swiper-initialized swiper-horizontal swiper-watch-progress swiper-backface-hidden">
        <div
          className="swiper-wrapper"
          id="swiper-wrapper-5496d11b7e2d2b70"
          aria-live="off"
          style={{ cursor: "grab" }}
        >
          <div
            className="swiper-slide swiper-slide-prev"
            role="group"
            aria-label="1 / 3"
          >
            <Box sx={{ 
              maxWidth: '1200px', 
              margin: '0 auto', 
              padding: { xs: '0px 0px', sm: '20px 15px', md: '25px 20px', lg: '30px 20px' },
              backgroundColor: '#ffffff'
            }}>
              <Grid container spacing={{ xs: 1, sm: 2, md: 10 }} alignItems="center">
                {/* Title - First on small screens */}
                <Grid item xs={12} sm={6} md={7} order={{ xs: 1, sm: 2 }}>
                  <Box sx={{ 
                    padding: { xs: '0px 0', sm: '10px 0', md: '15px 0' },
                    textAlign: { xs: 'center', sm: 'left' }
                  }}>
                    <Typography 
                      variant="h4" 
                      sx={{ 
                        fontWeight: '600',
                        color: '#1a1a1a',
                        fontSize: { xs: '1.2rem', sm: '1.3rem', md: '1.5rem', lg: '2rem' },
                        lineHeight: 1.2,
                        marginBottom: { xs: '0px', sm: '10px', md: '25px' }
                      }}
                    >
                      Travel with Peace of Mind
                    </Typography>
                  <Box
                  sx={{
                    display: { xs: 'none', sm: 'flex', md: 'flex' },
                    flexDirection: 'column',
                    gap: 1.5,
                  }}
                  >
                      <Typography 
                      variant="body1" 
                      sx={{ 
                        color: '#000000',
                        lineHeight: 1.7,
                        fontSize: { xs: '14px', sm: '15px', md: '16px', lg: '17px' },
                        mb: 0,
                        textAlign: { xs: 'center', sm: 'center', md: 'left' }
                      }}
                    >
                      Have you ever had a problem while traveling for business or
                      pleasure? I have been in that situation before and I do not
                      want to be unprepared again.
                    </Typography>
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        color: '#000000',
                        lineHeight: 1.7,
                        fontSize: { xs: '14px', sm: '15px', md: '16px', lg: '17px' },
                        textAlign: { xs: 'center', sm: 'center', md: 'left' }
                      }}
                    >
                      With FootprintlD, you well be able to travel with peace of mind 
                      and have access to the medical information that you need when 
                      you need it most.
                    </Typography>
                  </Box>
                  </Box>
                </Grid>

                {/* Image - Second on small screens */}
                <Grid item xs={12} sm={6} md={5} order={{ xs: 2, sm: 1 }}>
                  <Box sx={{ 
                    textAlign: 'center',
                    position: 'relative',
                    padding: { xs: '10px 0', sm: '10px 0', md: '0' }
                  }}>
                    <img
                      src="assets/images/friends.jpg"
                      alt="Travel with peace of mind"
                      style={{ 
                        width: '100%',
                        maxWidth: { xs: '280px', sm: '300px', md: '320px', lg: '340px' },
                        height: 'auto',
                        borderRadius: { xs: '12px', sm: '14px', md: '16px' },
                        boxShadow: '0 8px 25px rgba(0,0,0,0.15)',
                        transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                        cursor: 'pointer',
                        borderRadius: '12px',
                        filter: 'sepia(50%)'
                      }}
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'translateY(-8px)';
                        e.target.style.filter = 'sepia(50%) brightness(1.1)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'translateY(0)';
                        e.target.style.filter = 'sepia(0%)';
                      }}
                    />
                  </Box>
                </Grid>    

               
              </Grid>
              <Box
                  sx={{
                    display: { xs: 'flex', md: 'none',sm: 'none' },
                    flexDirection: 'column',
                    gap: 1.5
                  }}
                  >
                      <Typography 
                      variant="body1" 
                      sx={{ 
                        color: '#000000',
                        lineHeight: 1.7,
                        fontSize: { xs: '14px', sm: '15px', md: '16px', lg: '17px' },
                        mb: 0,
                        textAlign: { xs: 'center', sm: 'center', md: 'left' }
                      }}
                    >
                      Have you ever had a problem while traveling for business or
                      pleasure? I have been in that situation before and I do not
                      want to be unprepared again.
                    </Typography>
                    <Typography 
                      variant="body1" 
                      sx={{ 
                        color: '#000000',
                        lineHeight: 1.7,
                        fontSize: { xs: '14px', sm: '15px', md: '16px', lg: '17px' },
                        textAlign: { xs: 'center', sm: 'center', md: 'left' }
                      }}
                    >
                      With FootprintlD, you well be able to travel with peace of mind 
                      and have access to the medical information that you need when 
                      you need it most.
                    </Typography>
                </Box>
            </Box>
          </div>
        </div>
      </div>
    </div>
  );
}
